/**
 * DB fields: startDay / endDay (Hasura start_day / end_day).
 * Admin forms label them startDayOffset / endDayOffset.
 */

export function readPackageDayOffsets(pkg) {
  if (!pkg || typeof pkg !== 'object') return { start: null, end: null };
  const startRaw = pkg.startDayOffset ?? pkg.startDay ?? pkg.start_day;
  const endRaw = pkg.endDayOffset ?? pkg.endDay ?? pkg.end_day;
  const toNum = (raw) => {
    if (raw === null || raw === undefined || raw === '') return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  };
  return { start: toNum(startRaw), end: toNum(endRaw) };
}

/** Inclusive day count from absolute start/end indices on the itinerary. */
export function packageDayRangeCount(pkg) {
  const { start, end } = readPackageDayOffsets(pkg);
  if (start == null || end == null) return null;
  const lo = Math.min(start, end);
  const hi = Math.max(start, end);
  return Math.max(1, hi - lo + 1);
}

/** Trip duration for display; itinerary day 0 (pre-trip) is excluded from the count. */
export function packageTripDayCount(pkg) {
  const { start, end } = readPackageDayOffsets(pkg);
  if (start == null || end == null) return null;
  const lo = Math.min(start, end);
  const hi = Math.max(start, end);
  if (lo <= 0 && hi > 0) return Math.max(1, hi);
  return Math.max(1, hi - lo + 1);
}
